// The blindfolded person's whole interface: short tones and a spoken readback.

let ctx: AudioContext | null = null;

export function unlockAudio(): void {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
    // Speech synthesis also needs a user gesture on iOS.
    if ("speechSynthesis" in window) {
      const u = new SpeechSynthesisUtterance(" ");
      u.volume = 0;
      window.speechSynthesis.speak(u);
    }
  } catch { /* Sound is optional. */ }
}

function tone(freq: number, start: number, dur: number, vol = 0.14, type: OscillatorType = "sine"): void {
  if (!ctx) return;
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.value = freq;
  const t = ctx.currentTime + start;
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(vol, t + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(ctx.destination);
  o.start(t);
  o.stop(t + dur + 0.02);
}

export const cue = {
  deal() { tone(660, 0, 0.16); tone(880, 0.11, 0.22); },
  lock() { tone(520, 0, 0.06, 0.1, "triangle"); },
  hit() { tone(784, 0, 0.14, 0.16); tone(1047, 0.11, 0.2, 0.16); tone(1319, 0.23, 0.34, 0.14); },
  miss() { tone(247, 0, 0.26, 0.13, "triangle"); },
  neutral() { tone(392, 0, 0.2, 0.1); },
  done() { [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.13, 0.3, 0.13)); },
  retry() { tone(330, 0, 0.1, 0.1); tone(330, 0.16, 0.1, 0.1); },
};

let speaking = false;
export const isSpeaking = () => speaking;

export function say(text: string, onEnd?: () => void): void {
  if (!("speechSynthesis" in window)) { onEnd?.(); return; }
  const synth = window.speechSynthesis;
  synth.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.rate = 1.04;
  speaking = true;
  const finish = () => { speaking = false; onEnd?.(); };
  u.onend = finish;
  u.onerror = finish;
  synth.speak(u);
  // Some browsers never fire onend. Don't leave the mic off forever.
  setTimeout(() => { if (speaking) finish(); }, 2500 + text.length * 70);
}
